export default __webpack_public_path__ + "static/media/356EBC_27_0.07f9c4a6.woff2";